// src/pages/Blog.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import PageMeta from '../components/SEO/PageMeta';
import StructuredData from '../components/SEO/StructuredData';
import { Link } from 'react-router-dom';

const Blog = () => {
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language.split('-')[0];

    // Blog posts data - in a real app, this would come from a CMS or API
    // For now, we'll use static data that can be easily replaced
    const blogPosts = t('blog.posts', { returnObjects: true }) || [];

    return (
        <>
            <PageMeta
                title={t('blog.meta.title')}
                description={t('blog.meta.description')}
                keywords={t('blog.meta.keywords')}
                path="/blog"
            />
            <StructuredData type="page" page={{ name: t('nav.blog'), path: '/blog', kind: 'CollectionPage', description: t('blog.meta.description') }} />

            <div className="bg-white py-12">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    {/* Header */}
                    <div className="text-center mb-12">
                        <h1 className="text-4xl font-extrabold text-gray-900 sm:text-5xl">
                            {t('blog.title')}
                        </h1>
                        <p className="mt-4 text-xl text-gray-600">
                            {t('blog.subtitle')}
                        </p>
                    </div>

                    {/* Blog Posts Grid */}
                    <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
                        {Array.isArray(blogPosts) && blogPosts.map((post, index) => (
                            <article 
                                key={index} 
                                className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300"
                            >
                                {post.image && (
                                    <div className="h-48 bg-gray-200 overflow-hidden">
                                        <img 
                                            src={post.image} 
                                            alt={post.title}
                                            className="w-full h-full object-cover"
                                        />
                                    </div>
                                )}
                                <div className="p-6">
                                    <div className="text-sm text-gray-500 mb-2">
                                        {post.date && new Date(post.date).toLocaleDateString(currentLang === 'hu' ? 'hu-HU' : currentLang === 'ro' ? 'ro-RO' : currentLang === 'de' ? 'de-DE' : 'en-US')}
                                    </div>
                                    <h2 className="text-2xl font-bold text-gray-900 mb-3">
                                        {post.title}
                                    </h2>
                                    <p className="text-gray-600 mb-4 line-clamp-3 text-justify">
                                        {post.excerpt}
                                    </p>
                                    <Link
                                        to={`/blog/${post.slug}`}
                                        className="text-primary font-semibold hover:text-primary-hover inline-flex items-center"
                                    >
                                        {t('blog.read_more')}
                                        <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                        </svg>
                                    </Link>
                                </div>
                            </article>
                        ))}
                    </div>

                    {/* Empty State */}
                    {(!Array.isArray(blogPosts) || blogPosts.length === 0) && (
                        <div className="text-center py-12">
                            <p className="text-gray-500 text-lg">{t('blog.no_posts')}</p>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default Blog;

